// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReturnMailDto
 */
export interface IReturnMailDto {
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDto
     */
    original_mailing_type?: IReturnMailDtoOriginalMailingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReturnMailDto
     */
    resend_status?: IReturnMailDtoResendStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IReturnMailDtoOriginalMailingTypeEnum {
    WELCOME_LETTER = 'WELCOME_LETTER',
    ORPHAN_LETTER = 'ORPHAN_LETTER',
    STATEMENT = 'STATEMENT',
    TAX_FORM = 'TAX_FORM',
    UNKNOWN = 'UNKNOWN'
}
/**
* @export
* @enum {string}
*/
export enum IReturnMailDtoResendStatusEnum {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    SKIPPED = 'SKIPPED'
}


/**
 * Check if a given object implements the IReturnMailDto interface.
 */
export function instanceOfIReturnMailDto(value: object): value is IReturnMailDto {
    return true;
}

export function IReturnMailDtoFromJSON(json: any): IReturnMailDto {
    return IReturnMailDtoFromJSONTyped(json, false);
}

export function IReturnMailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnMailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'original_mailing_type': json['original_mailing_type'] == null ? undefined : json['original_mailing_type'],
        'resend_status': json['resend_status'] == null ? undefined : json['resend_status'],
    };
}

export function IReturnMailDtoToJSON(json: any): IReturnMailDto {
    return IReturnMailDtoToJSONTyped(json, false);
}

export function IReturnMailDtoToJSONTyped(value?: IReturnMailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original_mailing_type': value['original_mailing_type'],
        'resend_status': value['resend_status'],
    };
}

